import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { 
    Card, 
    CardContent, 
    CardHeader, 
    Divider, 
    FormGroup, 
    Grid, 
    Typography,
    TextField
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import get from 'lodash.get';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(2),
    },
    container: {
        gap: "0.5rem",
    },
    language: {
    }
}));

const Language = (props) => {
    const { className, useMetaDataSettings, languageSettingsContent, ...rest } = props;
    const gettingAvailableLanguages = useSelector(store => store.settings.gettingAvailableLanguages);
    const availableLanguages = useSelector(store => store.settings.availableLanguages);
    const {
        isLoading,
        settingsMetaData,
        isSettingsMetaDataUpdating,
        handleChange,
        LANGUAGE_CODE,
        onBlur,
        onFocus
    } = useMetaDataSettings;

    const languageDefault = get(settingsMetaData, LANGUAGE_CODE, null);
    
    const classes = useStyles();
    
    const SkeletonCardContent = () => {
        return (
            <CardContent>
                <Grid item md={6} xs={12}>
                    <Typography display="block" style={{ fontSize: '2.2rem' }}>
                    <Skeleton />
                    </Typography>
                </Grid>
            </CardContent>
        );
    };

    return (
        <Card {...rest} className={clsx(classes.root, className)}>
            <form>
                <CardHeader
                    subheader={languageSettingsContent?.description || `Manage the language settings`}
                    title={languageSettingsContent?.title || `Language`}
                />
                <Divider />
                {isLoading || gettingAvailableLanguages || isSettingsMetaDataUpdating ? (
                    <SkeletonCardContent /> 
                ) : (
                    <CardContent>
                        <Grid>
                            <FormGroup className={classes.container}>
                                <Grid className={classes.language}>
                                    <Autocomplete
                                        id="language"
                                        name={LANGUAGE_CODE}
                                        options={availableLanguages}
                                        getOptionLabel={(option) => option.language}
                                        style={{ width: 300 }}
                                        onBlur={() => onBlur(LANGUAGE_CODE)}
                                        onFocus={() => onFocus(LANGUAGE_CODE)}
                                        value={availableLanguages?.find(language => language.languageCode === languageDefault)}
                                        onChange={(e, option) => 
                                            handleChange({
                                                target: {
                                                    name: LANGUAGE_CODE,
                                                    value: option?.languageCode
                                                }
                                            })
                                        }
                                        renderInput={(params) => (
                                            <TextField 
                                                {...params} 
                                                label={languageSettingsContent?.languageDropdownLabel || `Language`} 
                                                variant="outlined" 
                                            />
                                        )}
                                    />
                                </Grid>
                            </FormGroup>
                        </Grid>
                    </CardContent>
                )}
            </form>
        </Card>
    );
};

Language.propTypes = {
    className: PropTypes.string,
    useMetaDataSettings: PropTypes.object
}
export default Language;